import type { ClaimStatus } from '@warehouse/shared';
import type { ReactNode } from 'react';

import { useClaimStatuses } from '../hooks/useClaimStatuses';

/**
 * A status pill painted with the colour from the editable catalog — the old
 * WMS's `complaint_statuses.color` column, now `app_settings`.
 *
 * The colour is arbitrary operator input, so it is applied as an inline style
 * (Tailwind cannot generate a class for a runtime hex) over a tinted background
 * derived from the same value.
 */
export function ClaimStatusBadge({ status }: { status: ClaimStatus }): ReactNode {
  const { label, color } = useClaimStatuses();
  const hex = color(status);

  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium"
      style={{ backgroundColor: `${hex}1f`, color: hex }}
      data-status={status}
    >
      <span className="size-1.5 rounded-full" style={{ backgroundColor: hex }} aria-hidden />
      {label(status)}
    </span>
  );
}
